<div class="full_width signin_bkg">
	<div class="center_v">
		<div class="signin_form">
			<div class="form-group">
				<label for="exampleInputEmail1">Email address</label>
				<input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email" #useremail>
				<small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
			</div>
			<div class="form-group">
				<label for="exampleInputPassword1">Password</label>
				<input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password" #userpassword >
			</div>
			<div class="form-check">
				<input type="checkbox" class="form-check-input" id="exampleCheck1" >
				<label class="form-check-label" for="exampleCheck1">Check me out</label>
			</div>
			<button type="submit" class="btn btn-primary" (click)="authService.SignIn(useremail.value, userpassword.value)">Submit</button>
		</div>
	</div>
</div>


